import React from "react";

const refurbisherRoute = [
  {
    key: "offers",
    path: "/refurbisher/offers",
    component: React.lazy(() => import("views/Refurbisher/Offers/OfferList")),
    authority: [],
  },

  {
    key: "offer-detail",
    path: "/refurbisher/offers/offer-detail/:offerId",
    component: React.lazy(() => import("views/Refurbisher/Offers/OfferDetail")),
    authority: [],
  },
];

export default refurbisherRoute;
